import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBitcoin, FaEthereum } from 'react-icons/fa';
import { SiTether } from 'react-icons/si';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const COIN_ICONS = {
  bitcoin: { icon: FaBitcoin, color: '#F7931A' },
  ethereum: { icon: FaEthereum, color: '#627EEA' },
  tether: { icon: SiTether, color: '#26A17B' },
};

export default function RatesTicker() {
  const [rates, setRates] = useState([]);

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/rates`);
        setRates(response.data.rates);
      } catch (error) {
        console.error('Failed to fetch rates:', error);
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 60000);
    return () => clearInterval(interval);
  }, []);

  const formatPrice = (price) => {
    if (!price) return '---';
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  // Duplicate rates for seamless scrolling
  const duplicatedRates = [...rates, ...rates];

  return (
    <div className="w-full bg-background-paper border-y border-border py-3 overflow-hidden" data-testid="rates-ticker">
      <div className="ticker-wrapper">
        <motion.div 
          className="ticker-content"
          animate={{ x: ['0%', '-50%'] }}
          transition={{ 
            repeat: Infinity, 
            duration: 20, 
            ease: 'linear' 
          }}
        >
          {duplicatedRates.map((rate, index) => {
            const CoinIcon = COIN_ICONS[rate.coin_id]?.icon || FaBitcoin;
            const coinColor = COIN_ICONS[rate.coin_id]?.color || '#F7931A';
            const isPositive = rate.change_24h >= 0;

            return (
              <div 
                key={`${rate.coin_id}-${index}`}
                className="flex items-center gap-6 px-8"
              >
                <div className="flex items-center gap-2">
                  <CoinIcon size={20} style={{ color: coinColor }} />
                  <span className="font-semibold text-text-primary">{rate.symbol}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-text-secondary">
                    Buy: <span className="text-accent-success font-mono">{formatPrice(rate.buy_rate)}</span>
                  </span>
                  <span className="text-text-secondary">
                    Sell: <span className="text-accent-danger font-mono">{formatPrice(rate.sell_rate)}</span>
                  </span>
                  <span className={`font-mono text-sm ${isPositive ? 'text-accent-success' : 'text-accent-danger'}`}>
                    {isPositive ? '+' : ''}{rate.change_24h?.toFixed(2) || 0}%
                  </span>
                </div>
              </div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
}
